/* eslint-disable no-console */
import constants from "../constants";

const {
  UPDATE_AMENTIES_STORE,
  UPDATE_AMENITY_STORE,
  REMOVE_AMENTIES_STORE,
  UPDATE_AMENITY_EVENTS_STORE,
  UPDATE_AMENITY_EVENT_STORE,
  REMOVE_AMENITY_EVENT_STORE,
} = constants;

const initialState = {
  amenities: {},
  amenityEvents: {},
};

export default (state = initialState, action) => {
  if (!action) return state;

  const { type } = action;

  switch (type) {
    // AMENITIES
    case UPDATE_AMENTIES_STORE:
      return { ...state, amenities: { ...action.data } };

    case UPDATE_AMENITY_STORE: {
      const amenityData = action?.amenityData;
      const uid = amenityData?.uid;

      return {
        ...state,
        amenities: {
          ...state.amenities,
          [uid]: { ...amenityData },
        },
      };
    }

    case REMOVE_AMENTIES_STORE: {
      const uidsToRemove = action?.removedIds || [];

      const updatedAmenities = { ...state.amenities };

      uidsToRemove.forEach((uid) => {
        if (uid && updatedAmenities[uid]) {
          delete updatedAmenities[uid];
        }
      });

      return {
        ...state,
        amenities: updatedAmenities,
      };
    }

    // AMENITY EVENTS
    case UPDATE_AMENITY_EVENTS_STORE: {
      return {
        ...state,
        amenityEvents: { ...(action.data || {}) },
      };
    }

    case UPDATE_AMENITY_EVENT_STORE: {
      const { event } = action.data || {};
      const { amenityId, id: eventId, clientReservationId } = event || {};

      if (!amenityId || !eventId || !clientReservationId) return state;

      return {
        ...state,
        amenityEvents: {
          ...state.amenityEvents,
          [amenityId]: {
            ...state.amenityEvents[amenityId],
            [clientReservationId]: {
              ...(state.amenityEvents[amenityId]?.[clientReservationId] || {}),
              [eventId]: event,
            },
          },
        },
      };
    }

    case REMOVE_AMENITY_EVENT_STORE: {
      const { amenityId, eventId, clientReservationId } = action.data || {};

      if (!amenityId || !eventId || !clientReservationId || !state.amenityEvents[amenityId]) {
        return state;
      }

      const updatedEventsByReservation = { ...state.amenityEvents[amenityId] };

      if (!updatedEventsByReservation[clientReservationId]) return state;

      const updatedReservationEvents = { ...updatedEventsByReservation[clientReservationId] };
      delete updatedReservationEvents[eventId];

      if (Object.keys(updatedReservationEvents).length === 0) {
        delete updatedEventsByReservation[clientReservationId];
      } else {
        updatedEventsByReservation[clientReservationId] = updatedReservationEvents;
      }

      return {
        ...state,
        amenityEvents: {
          ...state.amenityEvents,
          [amenityId]: updatedEventsByReservation,
        },
      };
    }
    default:
      return state;
  }
};
